import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@mui/material';

// INFO: For a MUI `helperText` prop. Returns bare nodes because TextField
// already wraps helperText in a `FormHelperText` (a `<p>`), so anything block
// level here is invalid HTML. The FormControl's `error` prop colors it red.
export const fieldErrorHelperText = (messages = []) => {
  if (!messages.length) {
    return null;
  }

  if (messages.length === 1) {
    return messages[0];
  }

  return messages.map((message, index) => (
    <span key={index} style={{ display: 'block' }}>
      {message}
    </span>
  ));
};

// INFO: For controls with no `helperText` slot — Select, RadioGroup, checkbox
// and repeated-row groups. Goes inside the FormControl as a sibling.
export default function FieldErrorText({ messages = [], style }) {
  if (!messages.length) {
    return null;
  }

  return (
    <FormHelperText error component='div' style={style}>
      {messages.length === 1
        ? messages[0]
        : messages.map((message, index) => <div key={index}>{message}</div>)}
    </FormHelperText>
  );
}

FieldErrorText.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
};
